import type { SVGProps } from "react";

export const Squarespace = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="global-navigation__logo global-navigation__logo--mobile"
    fill="none"
    height="24"
    viewBox="0 0 29 24"
    width="29"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Squarespace</title>
    <path
      clipRule="evenodd"
      d="M16.7766 4.95951L18.2028 6.4229L18.2005 6.42525L9.05818 15.8173C8.05824 16.8454 6.72423 17.4124 5.30496 17.4124C3.8857 17.4124 2.55168 16.8454 1.55174 15.8173C-0.517248 13.6904 -0.517248 10.2319 1.55174 8.10509L9.44064 0L10.8668 1.46339L2.97792 9.56847C1.69459 10.886 1.69459 13.0317 2.97792 14.3515C4.26125 15.6714 6.35098 15.6714 7.63431 14.3515L16.7766 4.95951ZM15.127 3.29851L6.02616 12.7046L4.6092 11.2389L13.71 1.83277C14.7053 0.802282 16.0324 0.235278 17.4448 0.235278C18.8571 0.235278 20.1842 0.802282 21.1796 1.83277L21.8892 2.56446L20.4699 4.0302L19.7603 3.29851C19.1428 2.65857 18.3226 2.30802 17.4448 2.30802C16.567 2.30802 15.7444 2.65857 15.127 3.29851ZM27.2483 8.18274C26.2483 7.1546 24.9143 6.5876 23.495 6.5876C22.0758 6.5876 20.7418 7.1546 19.7418 8.18274L10.5995 17.5748L12.0234 19.0381L21.1657 9.64612C22.449 8.32625 24.5388 8.3286 25.8221 9.64612C26.4419 10.2837 26.7852 11.133 26.7852 12.0388C26.7852 12.9446 26.4442 13.794 25.8221 14.4315L17.9332 22.5366L19.3594 24L27.2483 15.8949C29.3172 13.7681 29.3172 10.3096 27.2483 8.18274ZM22.775 11.2942L22.7762 11.293H22.7739L22.775 11.2942ZM22.775 11.2942L13.6754 20.6992C12.3967 22.019 10.3184 22.0214 9.03973 20.6992L8.33009 19.9675L6.91083 21.4332L7.62046 22.1649C8.61579 23.1954 9.94289 23.7624 11.3552 23.7624C12.7676 23.7624 14.0947 23.1954 15.09 22.1649L24.1908 12.7588L22.775 11.2942Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default Squarespace;
